
import React, { useState, useEffect } from 'react';
import { FiX, FiCheck, FiInfo } from 'react-icons/fi';
import { Slider } from '../../../../components/ds';

const HQConfigModal = ({ isOpen, onClose, onConfirm, currentCount = 1, symbol = '' }) => {
  const [count, setCount] = useState(currentCount);

  useEffect(() => {
    if (isOpen) {
      setCount(currentCount || 1);
    }
  }, [isOpen, currentCount]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
      {/* max-h + overflow-y-auto: the backdrop centres this panel, so in landscape
          (~375px of viewport height) the header and the Update button were clipped
          off both ends with no scroll to recover them. */}
      <div className="bg-bg-2 rounded-2xl shadow-xl w-full max-w-md max-h-[90vh] overflow-y-auto transform transition-all scale-100">
        <div className="p-6">
            <div className="flex justify-between items-start mb-6">
                <div>
                    <h3 className="ds-h3 text-fg-1">
                        HQ Data Configuration
                    </h3>
                    <p className="text-sm text-fg-2 mt-1">
                        Configure broker redundancy for {symbol}
                    </p>
                </div>
                {/* -m-2 p-3: 20px glyph + 24px padding = a 44px hit area, pulled
                    back so the optical alignment doesn't shift. The old
                    dark:hover:text-fg-3 equalled the base colour — hover was a
                    no-op in dark; the fg tokens are theme-aware, so one pair does
                    both themes. */}
                <button
                    onClick={onClose}
                    className="-m-2 p-3 rounded-lg text-fg-3 hover:text-fg-1 hover:bg-bg-3 transition-colors"
                    title="Close"
                >
                    <FiX size={20} />
                </button>
            </div>

            <div className="space-y-6">
                {/* DS Slider: same native <input type="range"> underneath (so the
                    1–5 step semantics and keyboard arrows are unchanged) but it
                    carries the label/value/anchor chrome and, crucially, the
                    coarse-pointer rule that grows the thumb to 22px on a phone —
                    the bare h-2 track was a fiddly touch target. */}
                <Slider
                    label="Concurrent Brokers"
                    value={count}
                    min={1}
                    max={5}
                    step={1}
                    onChange={(v) => setCount(v)}
                    minLabel="1 (Single)"
                    maxLabel="5 (Max)"
                />

                <div className="bg-accent/10 p-4 rounded-xl border border-accent/25 flex gap-3">
                    <FiInfo className="text-accent shrink-0 mt-0.5" />
                    <div className="text-sm text-fg-2">
                        <p className="font-medium mb-1 text-fg-1">Impact of Multi-Broker Mode</p>
                        <ul className="list-disc list-inside space-y-1 opacity-90 text-xs">
                           <li>Count 1: Standard single connection</li>
                           <li>Count 2+: Fuses data from multiple sources for lower latency and higher reliability</li>
                           <li>Requires active sessions on multiple admin broker accounts</li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* Stack below sm: side-by-side these two had ~13px of slack at 375px,
                so any label growth (or a larger font scale) pushed them out.
                col-reverse keeps the primary action on top on a phone. */}
            <div className="mt-8 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
                <button
                    type="button"
                    onClick={onClose}
                    className="btn btn-secondary w-full justify-center sm:w-auto"
                >
                    Cancel
                </button>
                <button
                    type="button"
                    onClick={() => onConfirm(count)}
                    className="btn btn-primary flex w-full items-center justify-center gap-2 sm:w-auto"
                >
                    <FiCheck /> Update Configuration
                </button>
            </div>
        </div>
      </div>
    </div>
  );
};

export default HQConfigModal;
